import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import styled from 'styled-components'

import { FlexColumn } from '@/@bothrs-ui/web/components/layout'
import { Span } from '@/@bothrs-ui/web/components/typography/Body'

const StTimelineActivityCardContainer = styled.div<{
  hasPassed?: boolean
  selected?: boolean
}>`
  ${({ theme, hasPassed, selected }) => {
    return `
      cursor:pointer;
      width: 100%;
      display: flex;
      padding: 16px;
      flex-direction: column;
      align-items: flex-start;
      gap: 12px;
      flex: 1 0 0;
      border-radius: 12px;
      border: 1px solid ${theme.Components.Card.Border};
      border-color: ${theme.Components.Card.Border};
      background: ${selected ? theme.Colors.Neutrals.Lighter : theme.Components.Card.Fill};
      transition: background 0.2s ease-in-out;
      &:hover {
        background: ${theme.Colors.Neutrals.Lighter};
      }

      ${hasPassed && `opacity: 0.5;`}
    `
  }}
`

const StTimelineActivityCardContent = styled(FlexColumn)`
  width: 100%;
  gap: 4px;
`

const StTimelineActivityCardIcon = styled(FontAwesomeIcon)`
  position: absolute;
  bottom: 20px;
  right: 24px;
`

const StTimelineActivityCardDescription = styled(Span)<{ color?: string }>`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: ${({ color }) => color};
`

export {
  StTimelineActivityCardContainer,
  StTimelineActivityCardContent,
  StTimelineActivityCardDescription,
  StTimelineActivityCardIcon,
}
